import type { CustomPalette, Partialize } from '@/types/declaration';

export const customColors: Partialize<CustomPalette> = {
  blue: {
    50: '#F0F3F6',
    100: '#EBF4FF',
    200: '#E0F2FE',
    300: '#A0CFFF',
    400: '#5A82FF',
    500: '#3449FF',
    600: '#2F3EBF',
    700: '#0717A3',
    800: '#051078',
    900: '#03095C'
  },
  orange: {
    100: '#FFE4D6',
    200: '#FFC9AD',
    300: '#FFAD85',
    400: '#FF9262',
    500: '#F0501D',
    600: '#D44618',
    700: '#B83C14',
    800: '#94320F',
    900: '#74280C'
  },
  gray: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827',
    950: '#111619'
  },
  warning: {
    main: '#FFE6A1',
    light: '#FFE6A1',
    dark: '#FF8C00'
  },
  error: {
    main: '#FF4F17',
    light: '#FFE6DE',
    dark: '#FF4F17'
  }
};

export const fontWeight = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700
};

export const DESKTOP_HEADER_HEIGHT = 74;
export const MOBILE_HEADER_HEIGHT = 50;

export const MOBILE_MIN_WIDTH = 344;
// export const DESKTOP_MAX_WIDTH = 1440;
export const DESKTOP_CONTENTS_MAX_WIDTH = 1440;

export const MOBILE_MAX_WIDTH = 768;

export const getButtonCommonStyles = (size: 'xs' | 's' | 'm' | 'l' | 'xl' | '2xl') => {
  let paddingY = 7;
  let paddingX = 14;
  let fontSize = 14;

  switch (size) {
    case 'xs':
      paddingY = 4;
      paddingX = 10;
      break;

    case 'm':
      paddingY = 9;
      break;
    case 'l':
      paddingY = 12;
      fontSize = 16;
      break;
    case 'xl':
      paddingY = 14;
      fontSize = 18;
      break;
    case '2xl':
      paddingY = 20;
      paddingX = 32;
      fontSize = 24;
      break;
    case 's':
    default:
      break;
  }

  return {
    paddingX: `${paddingX}px`,
    paddingY: `${paddingY}px`,
    fontSize: `${fontSize}px`,
    borderRadius: '8px'
  };
};

export const glitterEffectStyles = {
  position: 'relative',
  transition: 'all 300ms',
  overflow: 'hidden',
  ':before': {
    position: 'absolute',
    top: 0,
    left: '-10%',
    content: '""',
    display: 'block',
    width: '8%',
    height: '100%',
    transform: 'skewX(-20deg)',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    boxShadow: '0 0 10px rgba(255, 255, 255, 0.8)',
    opacity: 1
  },

  ':hover:before': {
    left: '100%',
    transition: 'all 750ms ease-in',
    opacity: 0
  }
};
